/**
 * Subcontratos list
 *
 */
import { Divider, message, Spin, Input } from 'antd'
import React from 'react'
import Api from '../../../Api'
import Exception from '../../../Exception'
import numeral from 'numeral'
import { Panel } from '../../../components'
import { connect } from 'react-redux'

/**
 *
 * @param {string} search
 * @returns
 */
function queryRecords(search) {
  const likeSearch = { $like: `%${search}%`}
  const filter = (!search) || (search.length === 0) ? null : {
    $or: [
      { sContrato: likeSearch },
      { sNombreCorto: likeSearch },
      { mDescripcionCorta: likeSearch },
    ]
  }

  return Api.query({
    model: 'CmrProject',
    attributes: [
      'iId',
      'sContrato',
      'sNombreCorto',
      'sCodigo',
      'dMonto',
    ],

    include: [{
      as: 'ordenServicio',
      required: true,
      attributes: [
        ['sConsecutivo', 'folio']
      ],
      where: {
        iId_proveedor: Api.getProviderId(),
      }
    }],

    where: {
      iActivo: true,
      iSubContrato: true,
      lStatus: 'ACTIVO',
      ...filter
    },
    order: [
      ['iId', 'DESC']
    ]
  })
}

/**
 *
 * @param {{ seleccionadoId?: number, onSelect?({ id: string }): void }} props
 */
function RawSubContratistaProyectos(props) {
  const [loading, setLoading] = React.useState(false)
  const [records, setRecords] = React.useState([])

  /**
   *
   * @param {string} search
   */
  const fetch = (search) => {
    setLoading(true)

    queryRecords(search)
      .then(r => {
        setRecords(r.data)
        setLoading(false)
      })
      .catch(e => {
        setLoading(false)
        message.error((new Exception(e)).toComponent())
      })
  }

  /**
   * onLoad
   *
   */
  React.useEffect(() => {
    fetch()
  }, [])

  return (
    <Panel style={{ ...props.style, display: 'flex', flexDirection: 'column', padding: 10 }}>
      <h3>Sub Contratos</h3>

      {/* search */}
      <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 1, marginRight: loading ? 10 : 0 }}>
          <Input.Search placeholder='Buscar' onSearch={text => fetch(text)} />
        </div>

        <div>
          {!loading ? null : (
            <Spin />
          )}
        </div>
      </div>

      {/* records */}
      <div style={{ position: 'relative', flex: 1, width: 250 }}>
        <div style={styles.cards.root}>
          {[{ iId: null }].concat(records).map((item, idx, arr) => {
            const seleccionado = item.iId === props.seleccionadoId
            const accentStyle = seleccionado ? { color: props.theme.colors.accent } : null

            if (item.iId) {
              return (
                <div key={item.iId.toString()} style={styles.card.root} onClick={() => props.onSelect && props.onSelect(item.iId)}>
                  <div style={styles.card.info}>
                    <div style={{ marginRight: 12 }}>
                      <label>{item.ordenServicio.folio}</label>
                      <h3 style={accentStyle}>{item.sContrato}</h3>
                      <label>{item.sCodigo}</label>
                      <h4>{numeral(item.dMonto).format('$0,0.00')}</h4>
                      <h5>{item.sNombreCorto}</h5>
                    </div>

                  </div>

                  {idx < (arr.length - 1) ? <Divider style={{ margin: '10px 0' }} /> : null}
                </div>
              )
            }

            return (
              <div key={'-'} style={styles.card.root} onClick={() => props.onSelect && props.onSelect(item.iId)}>
                <div style={styles.card.info}>
                  <div style={{ marginRight: 12 }}>
                    <label>TODOS</label>
                    <h3 style={accentStyle}>TODOS LOS SUBCONTRATOS</h3>
                  </div>
                </div>

                {idx < (arr.length - 1) ? <Divider style={{ margin: '10px 0' }} /> : null}
              </div>
            )
          })}
        </div>
      </div>
    </Panel>
  )
}

const styles = {
  cards: {
    root: {
      overflowY: 'auto',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  },

  card: {
    root: {
      cursor: 'pointer',
      padding: 0,

      display: 'flex',
      flexDirection: 'column',
    },

    info: {
      flex: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
}


export const SubContratistaProyectos = connect(
  state => ({ theme: state.theme.values })
)(RawSubContratistaProyectos)
